import script from "./BreadCrumbComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./BreadCrumbComponent.vue?vue&type=script&setup=true&lang=ts"

import "./BreadCrumbComponent.vue?vue&type=style&index=0&id=3bea2050&scoped=true&lang=scss"

import exportComponent from "D:\\J\\workspace\\FusionServer\\QUA\\Manitou.FusionServer.Web.DiagPortalFront\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bea2050"]])

export default __exports__